module.exports = new __parcel__URL__("SmartButtonSpotlightHeader.b4b7c8dc.png").toString();